import React, { useState, useId } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type AccordionItem = {
  title: string;
  description: string;
  icon: React.ReactNode;
  previewImage?: string;
  previewAlt?: string;
};
type AccordionProps = {
  items: AccordionItem[];
  tone?: 'light' | 'dark';
};
export function Accordion({
  items,
  tone = 'light'
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const baseId = useId();
  return <div className={`accordion-list accordion-list--${tone}`} data-id="element-1">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `${baseId}-panel-${index}`;
      return <div className="accordion-item" key={item.title} data-id="element-2">
            <button type="button" className={`accordion-trigger ${item.previewImage ? 'accordion-trigger--preview' : ''}`} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-3">
              {item.previewImage && <span className="accordion-preview" aria-hidden="true" data-id="element-4">
                  <img src={item.previewImage} alt={item.previewAlt ?? ''} data-id="element-5" />
                </span>}
              <span className="accordion-icon" aria-hidden="true" data-id="element-6">
                {item.icon}
              </span>
              <span className="accordion-title" data-id="element-7">{item.title}</span>
              <ChevronDownIcon className={`chevron ${isOpen ? 'chevron--open' : ''}`} size={19} aria-hidden="true" data-id="element-8" />
            </button>
            <div id={panelId} className={`accordion-panel ${isOpen ? 'accordion-panel--open' : ''}`} aria-hidden={!isOpen} data-id="element-9">
              <p data-id="element-10">{item.description}</p>
            </div>
          </div>;
    })}
    </div>;
}